/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
export default {
  CHANGE: function CHANGE(state, item) {
    state.change = item;
  },
  CLASSIFY: function CLASSIFY(state, item) {
    state.classifyId = item;
  },
  HEADERNAME: function HEADERNAME(state, item) {
    state.headerName = item;
  },
  CVU: function CVU(state, item) {
    state.courseVideUrl = item;
  },
  WXUSERINFO: function WXUSERINFO(state, item) {
    state.wxUserInfo = item;
  },
  SET_INTEGRAL: function SET_INTEGRAL(state, integral) {
    if (state.wxUserInfo.userIntegral) {
      state.wxUserInfo.userIntegral = integral;
    }
  },
  FLOWERCOUNT: function FLOWERCOUNT(state, item) {
    state.flowerCount = item;
  },
  LOADINGCOVER: function LOADINGCOVER(state, item) {
    state.loadingCover = item;
  },
  CLOSEGIFTBOX: function CLOSEGIFTBOX(state, item) {
    state.closeGiftBox = item;
  },
  IS_XCX: function IS_XCX(state, item) {
    state.isXCX = item;
  },
  CHANGE_categoriesList: function CHANGE_categoriesList(state, item) {
    state.categoriesList = item;
  },
  ISBUTTONACTIVE: function ISBUTTONACTIVE(state, item) {
    state.isButtonActive = item;
  }
};